<template>
  <div class="skeleton">
    <div class="skeleton-item1"></div>
    <div class="skeleton-item2"></div>
    <div class="skeleton-item3"></div>
    <div class="skeleton-item4"></div>
  </div>
</template>
  
  <script lang="ts">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "market-skeleton",
});
</script>
  
<style scoped>
.skeleton div {
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: skeleton-animation;
  animation-timing-function: linear;
  background-size: 1000px 100%;
  background: linear-gradient(90deg, #d8d8d8 8%, #f8faff 18%, #d8d8d8 33%);
}
.skeleton-item1 {
  border-radius: 32px;
  width: 576px;
  height: 66px;
  margin: 0px 0px 52px 38px;
}

.skeleton-item2 {
  border-radius: 32px;
  width: 670px;
  height: 66px;
  margin: 0px 0px 40px 38px;
}

.skeleton-item3 {
  border-radius: 40px;
  width: 666px;
  height: 540px;
  margin: 0px 0px 52px 42px;
}

.skeleton-item4 {
  border-radius: 40px;
  width: 666px;
  height: 298px;
  margin-left: 42px;
}

@keyframes skeleton-animation {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}
</style>
  